import PropTypes from 'prop-types';
import React from 'react';

const CheckInTime = ({ deal, isTravel = false, theme }) => {
  if (!isTravel) {
    return null;
  }

  return (
    <>
      <div className="deal-main-deal__check-in-times">
        {deal?.travelCheckIn && (
          <p>
            <b>Check in: </b>
            {deal?.travelCheckIn}
          </p>
        )}
        {deal?.travelCheckOut && (
          <p>
            <b>Check out: </b>
            {deal?.travelCheckOut}
          </p>
        )}
      </div>
      <style jsx>
        {`
          .deal-main-deal__check-in-times {
            display: flex;
            width: calc(100% - 85px);
            color: ${theme.colors.primary};
          }

          .deal-main-deal__check-in-times p:last-child {
            margin-left: 10px;
          }
          .deal-main-deal__check-in-times p:first-child {
            margin-left: 0px;
          }
        `}
      </style>
    </>
  );
};

CheckInTime.propTypes = {
  deal: PropTypes.object.isRequired,
  isTravel: PropTypes.bool,
  theme: PropTypes.object.isRequired,
};

export default CheckInTime;
